(function () {
    'use strict';

    angular
        .module('franchiser.constants')
        .constant('PATHS_FRANCHISER', {
            PHYSICAL: '/app/src/angular/franchiser'
        });
}());